/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CognitoPaymentStatus {
	Canceled = 'Canceled',
	Disputed = 'Disputed',
	PartiallyRefunded = 'PartiallyRefunded',
	Pending = 'Pending',
	Refunded = 'Refunded',
	Succeeded = 'Succeeded',
	Declined = 'Declined',
	Reversed = 'Reversed',
	PartiallyReversed = 'PartiallyReversed',
}
